import React, {useState, useEffect} from 'react';

import { useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  MenuItem,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import Swal from 'sweetalert2';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

import ContentMarketingService from '../../services/contentMarketing.service';

import { fileTypes } from '../../constants/models/fileTypes';

import '../../styles/style.scss';
import '../../styles/createContentStyle.scss';

export const CreateContentMarketingScreen = (props) => {

  const fileUpdate = props.match.params.id;

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const dispatch = useDispatch();
  const history = useHistory();

  const [isDisabled, setDisabled] = useState(true);
  const [isLoadingData, setIsLoadingData] = useState(true);

  const [ changeFile, setChangeFile] = useState(fileUpdate ? false : true);
  const [ file, setFile ] = useState(null);
  const [ fileName, setFileName ] = useState(null);

  const [ isSelectFile, setIsSelectFile ] = useState(false);
  const [ selectedStyleFile, setSelectedStyleFile ] = useState({
    icon:'',
    style:''
  });

  const [contentSection, setContentSection] = useState(['']);

  const [fileResponse, setFileResponse] = useState({
    nameContent: '',
    section: '',
    file: ''
  });

  const [isLoadingForm, setIsLoadingForm] = useState(false);

  const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });

  const validationSchema = Yup.object().shape({
    nameContent: Yup.string().required('Nombre del documento es requerido')
                    .matches(/^[A-zÀ-ú\d\-_\s]+$/i, "Solo se admiten letras y numero. No se admiten acentos."),
    section: Yup.string().required('Sección es requerida')
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  /** 
   * Ejecuta una vez servicio para recuperar lista de secciones y la informacion del contenido a actualizar si se cumple la condición
   * -author alSanchez - ETE
   * -version 1.0.0 - Septiembre 2021
   * 
  */
  useEffect(() => {
    ContentMarketingService.getSections().then((responseSection)=>{
      setContentSection(responseSection);
      if(fileUpdate){
        ContentMarketingService.getFileByName(fileUpdate).then(
          (responseFile) => {
              console.log('ok');
              const dataResponse = {
                nameContent: responseFile.name,
                section:responseFile.section,
                file: responseFile.document
              }
              setFileResponse(dataResponse);
              reset(dataResponse);
              if(dataResponse && dataResponse.file){
                setFile(dataResponse.file);
                changeStyleFile(dataResponse.file, dataResponse.nameContent);
                setDisabled(false);
              }
              setIsLoadingData(false);
          },
          (error) => {
              console.log('error data');
              setIsLoadingData(false);
              
              actionErrorConnection(error, 'Error al recuperar documento');
          }
        );
      } else{
        setIsLoadingData(false);
      }
  }).catch((error)=>{
      setContentSection([]);
      setIsLoadingData(false);

      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 
            ( error?.response?.data) ?'No existen Secciones':'Error al recuperar secciones');
        }
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[fileUpdate, reset]);

  /**
   * Cambiar de pagina al realizar una solicitud afirmativa
   * @param {*} result - respuesta de la solicitud
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2021
   */
  const getReturnPage = (result) => {
    if (result.isConfirmed) {
      props.history.push('/administration/content/marketing');
        window.location.reload();
    }
  }

  /**
   * Realiza la cancelación de envio del formulario y regresa a la pagina de contenidos
   * @param { string } response - tipo de cancelación realizada
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const handleCancel = (response) => {

    let responseTitle = '';

    if(response === 'return'){
      responseTitle = 'Regresar';
    } else if(response === 'cancel'){
      responseTitle = 'Cancelar';
    }
    swalCustomButtons.fire({
      title: responseTitle,
      text: "Esta acción eliminará toda información no guardada.",
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
        getReturnPage(result);
    })
  }

  /**
   * Cambia de estado cuando se ha seleccionado un archivo
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const handleChangeFile = () => {
    setChangeFile(true);
  }

  /**
   * Recupera la información del archivo cargado
   * @param {*} fileData - informacion del archivo
   * @param {*} cb - respuesta de la solicitud
   * @returns 
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const fileToBase64 = (fileData, cb) => {

    if (!fileData){
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(fileData)
    reader.onload = function () {
      cb(null, reader.result)
    }
    reader.onerror = function (error) {
      cb(error, null)
    }
  }

/**
 * Cambia estilo del imput de carga de archivo de acuerdo al tipo de archivo subido
 * @param {*} result - data del archivo subido
 * @param {*} fileUpdateName - nombre del archivo
 * @author alSanchez - ETE
 * @version 1.0.0 - Septiembre 2021
 */
  const changeStyleFile = (result,fileUpdateName) =>{
    const fileType = result.split(',')[0].split(':')[1].split(';')[0];

    const fileProperties = fileTypes.find(data => data.type === fileType);

    if(fileProperties){
      setSelectedStyleFile({
        icon:fileProperties.icon,
        style: fileProperties.style
      });

      const fileNameSplit = fileUpdateName.split('.');
      setFileName(fileNameSplit[1]? fileUpdateName : `${fileNameSplit[0]}.${fileProperties.fileExtension}`);
    }
    setIsSelectFile(true);
  }

  /**
   * Recupera el archivo cargado
   * @param {*} target - recupera la información del imput de carga de archivo 
   * @returns 
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const onUploadFileChange = ({ target }) => {
    if (target.files < 1 || !target.validity.valid) {
      return
    }
    fileToBase64(target.files[0], (err, result) => {
      if (result) {
        setFile(result);
        setFileName(target.files[0]);
        changeStyleFile(result, target.files[0].name);
        

      }
    })

    setDisabled(false);
  }

  /**
   * Cambia los datos del formulario de acuerdo a la entrada seleccionada
   * @param {*} event - recupera información del imput seleccionado
   * @param {*} id - recupera el tipo de imput seleccionado
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const handleChangeValue =(event, id) =>{
    switch (id) {
      case 'nameContent':
        setFileResponse({...fileResponse, nameContent : event.target.value});
        break;
      case'section': 
      setFileResponse({...fileResponse, section : event.target.value});
        break;
      default:
        break;
    }
  }

  /**
   * Envia la información del formulario del formulario para crear o actualizar contenidos
   * @param {*} data - datos del formulario
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2021
   */
  const onSubmit = async(data) => {

    setIsLoadingForm(true);

    let dataContent = [];

    if (data && file){
      dataContent = {
        'id': fileUpdate && Number(fileUpdate) ,
        'nameContent' : fileResponse.nameContent,
        'section' : fileResponse.section,
        'file' : file
      }
    }

    if(fileUpdate){
      getUpdateService(dataContent);
    } else {
      getCreateService(dataContent);
    }
  };

  /**
   * Realiza la conexión con el servicio de actualizacion de contenido
   * @param {array} dataContent - información del archivo
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2021
   */
  const getUpdateService = (dataContent) =>{
    ContentMarketingService.getUpdateContent(dataContent).then(()=>{
      setIsLoadingForm(false);
      Swal.fire({
        icon: 'success',
        title: 'Contenido actualizado.',
        showConfirmButton: true,
        confirmButtonText: 'Regresar'
      })
      .then((result) => {
          getReturnPage(result);
      });    
    }).catch((error)=>{
      setIsLoadingForm(false);
      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al actualizar contenido.');
        }
    });
  }

  /**
   * Realiza la conexión con el servicio de creación de contenido
   * @param {array} dataContent - información del archivo
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2021
   */
  const getCreateService = (dataContent) =>{
    ContentMarketingService.getCreateContent(dataContent).then(()=>{
      setIsLoadingForm(false);
      setFileResponse({
        nameContent: '',
        section: '',
        file: ''
      });
      setFile(null);
      setFileName(null);
      setIsSelectFile(false);
      setSelectedStyleFile({
        icon:'',
        style:''
      });
      document.getElementById('file').value= null;

      Swal.fire({
        icon: 'success',
        title: 'Nuevo contenido creado.',
        showConfirmButton: true,
        confirmButtonText: 'Regresar'
      })
      .then((result) => {
          getReturnPage(result);
      }); 
      
    }).catch((error)=>{
      setIsLoadingForm(false);
      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al crear contenido.');
        }
    });
  }

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />


                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                      <div className="row">
                        <div className="col-10 text-title">
                          <span>Contenido </span>
                          <i className="fas fa-angle-right ms-2 me-2"></i>
                          <span>Avisos</span>
                          <i className="fas fa-angle-right ms-2 me-2"></i>
                          <span>{fileUpdate ? 'Actualizar' : 'Nuevo contenido'}</span>
                        </div>
                        <div className="col-2 text-title">
                          <div className="w-100 d-flex justify-content-end">
                            <Tooltip title="Regresar" placement="top-start" arrow>
                              <button className="btn custom-btn-icons" 
                              type="button" 
                              onClick={()=>handleCancel('return')}
                              >
                                <i className="fas fa-angle-left custom-icon-return"></i>
                              </button>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                      <form>
                        <div className="container p-0">
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle" >Información general</span>
                              </div>
                            </div>
                            <div className="col-md-9 pt-5 pb-2">
                              <div className="row">
                                <div className="col-md-6 mt-2 mb-2">
                                  <TextField
                                    required
                                    className="w-100"
                                    id="nameContent"
                                    name="nameContent"
                                    label="Nombre del contenido"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    disabled={!!fileUpdate}
                                    {...register('nameContent')}
                                    error={!!errors?.nameContent}
                                    value={fileResponse.nameContent ||''}
                                    onChange={event => handleChangeValue(event, 'nameContent')}
                                    
                                  />
                                  <Typography variant="inherit" color="error">
                                      {errors?.nameContent?.message}
                                  </Typography>
                                </div>
                                
                                <div className="col-md-6 mt-2 mb-2">
                                  <TextField
                                    select
                                    required={!isLoadingData}
                                    id="section"
                                    name="section"
                                    variant="outlined"
                                    size="small"
                                    disabled={isLoadingData}
                                    label={ isLoadingData ? <div className="fa-1x"> <i className="fas fa-spinner fa-spin"></i></div> : "Sección"}
                                    fullWidth
                                    {...register('section', { required: true })}
                                    value={fileResponse.section || ''}
                                    onChange={event => handleChangeValue(event, 'section')}
                                    >
                                        <MenuItem value="">Seleccionar sección</MenuItem>
                                    {contentSection.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <Typography variant="inherit" color="error">
                                      {errors.section?.message}
                                  </Typography>
                                </div>
                              </div> 
                            </div>
                          </div>
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle">Cargar archivo</span>
                              </div>
                            </div>
                            <div className="col-md-9 pt-5">
                              <div className="row">
                              <Tooltip title={fileName ? `Archivo cargado: ${fileName}`: 'No se ha cargado archivo'} placement="top-start" arrow>
                                <div className="col-md-12 mt-2 mb-2 input-group">
                                
                                { (fileUpdate && !changeFile) &&
                                  <>
                                    <button 
                                      className="btn custom-change-btn" 
                                      type="button" 
                                      onClick={handleChangeFile}
                                      id="upload-file"
                                    >Cambiar archivo</button>
                                    <label htmlFor='upload-file' className="input-group-text">Archivo cargado</label>
                                  </>
                                }
                                  { (changeFile) &&
                                    <>
                                      <input 
                                        type="file" 
                                        name="file" 
                                        id="file"
                                        className="form-control" 
                                        accept="application/pdf,
                                          application/vnd.ms-excel,
                                          application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                          application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        onChange={onUploadFileChange}
                                      /> 
                                    </>
                                  }
                                  
                                  <span className={`input-group-text ${isSelectFile ? 'd-block' : 'd-none' } bg-white`}>
                                    <i className={`fas ${selectedStyleFile.icon} ${selectedStyleFile.style}`}></i>
                                  </span>
                                </div>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex flex-row-reverse ">
                            <div className="col-md-9 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                              <button  
                              className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                              onClick={handleSubmit(onSubmit)}
                              disabled={ isDisabled || isLoadingForm}>
                                <span className="me-2">{fileUpdate ? 'Actualizar' : 'Agregar'}</span>
                                {
                                    isLoadingForm
                                    ? <i className="fas fa-spinner fa-spin"></i>
                                    : <i className="fas fa-save"></i>
                                } 
                              </button>
                              <button  
                              className="btn custom-cancel-btn pt-2 pb-2 ps-3 pe-3 me-3"
                              type="button" 
                              onClick={()=>handleCancel('cancel')}>
                                    Cancelar
                              </button>
                            </div>
                          </div>
                          
                        </div>
                      </form>
                    </div>
                      
                     
                    
                  </div>
                </div>

                </div>
            </div>
          </div>
        
           
            <Footer/>
        </>
    )
}

CreateContentMarketingScreen.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  history: PropTypes.object
}
